/**
 * Converts a timestamp string to a time string in the format 'HH:mm'.
 *
 * @param {string} timestamp - The timestamp string to convert.
 * @return {string} The time string in the format 'HH:mm'.
 */
export function convertTimestampToTime(timestamp: string): string {
  // Create a new Date object from the timestamp string
  const date = new Date(timestamp);

  // Get the hours, padded with leading zeros if necessary
  const hours = date.getHours().toString().padStart(2, "0");

  // Get the minutes, padded with leading zeros if necessary
  const minutes = date.getMinutes().toString().padStart(2, "0");

  // Return the time string in the format 'HH:mm'
  return `${hours}:${minutes}`;
}
